import React, { useEffect, useState } from 'react';

// import { Breadcrumb } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
import DynamicBeadCrumbs from 'Components/Shared/DynamicBreadCrumbs';

const defautlItems = [
    {
        link: '/',
        name: 'Home',
    },
    {
        link: '/admin',
        name: 'Admin',
    },
];

const Navigator = ({ section, sectionUrl, action }) => {
    const [items, setItems] = useState(defautlItems);

    useEffect(() => {
        const modifiedItems = [
            ...defautlItems,
            {
                link: sectionUrl ? `/admin/${sectionUrl}` : '',
                name: section,
                active: sectionUrl ? true : false,
            },
        ];
        if (action)
            modifiedItems.push({
                link: '',
                name: action,
                active: true,
            });
        setItems(modifiedItems);
    }, [section, sectionUrl, action]);

    return <DynamicBeadCrumbs items={items} />;
};

export default Navigator;
